// extracted by mini-css-extract-plugin
export default {"header":"_3qR-yOf2","linkInputGroup":"_3udttlV4","copyIcon":"eEIyinIT","copyStatus":"_3KW2Jou_","shareHeading":"FPlnYyEF","qrCode":"_1GR21bQf"};